<template>
  <div>
    <b-carousel id="login-section" indicators :interval="4000">
      <!-- Les images de fond d'écran sont à paramétrer dans le css de la vue -->
    <b-carousel-slide id="slide-1" class="full-screen"></b-carousel-slide>
    <b-carousel-slide id="slide-2" class="full-screen"></b-carousel-slide>
    <b-carousel-slide id="slide-3" class="full-screen"></b-carousel-slide>
    <b-carousel-slide id="slide-4" class="full-screen"></b-carousel-slide>
    <b-container class="login-form-container col-sm-12 col-md-10">
      <b-row class="text-center" align-v="center" align-h="start">
        <b-col class="bg-light login-card  col-sm-12 col-md-6 col-lg-5 col-xl-4">
          <img src="@/assets/logo_full.png" class="d-inline-block align-left logo" alt="Logo ICDL"/>
          <h1>Bienvenue sur <br> Digital Citizen</h1>
          <b-link href="#about">En savoir plus</b-link>
          <b-form @submit.prevent="onSubmit" id="login-form">
            <h3>Connectez vous</h3>
            <span class="subtitle">Vos identifiants de connexion vous sont fournis sur la première page de votre cahier de formation.</span>
            <b-form-group
              id="input-group-1"
              label="Identifiant:"
              label-for="input-1"
              description=""
            >
              <b-form-input
                id="input-1"
                v-model="loginForm.username"
                placeholder="N° de livret ou adresse email"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-2" label="Mot de passe:" label-for="input-2">
              <span id="pwd-field">
                <b-form-input
                  id="input-2"
                  :type="passwordInput.type"
                  v-model="loginForm.password"
                  placeholder="Veuillez entrer votre mot de passe"
                  required
                  class="input"
                ></b-form-input>
                <b-button @click="showPassword()" v-b-tooltip.hover title="Afficher le mot de passe">
                  <b-icon-eye-fill v-if="passwordInput.show"></b-icon-eye-fill>
                  <b-icon-eye-slash-fill v-else></b-icon-eye-slash-fill>
                </b-button>
              </span>
          <b-link :to="{name: 'ForgottenPassword'}">Mot de passe oublié ?</b-link>
            </b-form-group>
            <b-alert :show="error.status" variant="danger" class="login-error">
              <p><b>{{ error.current.title }}</b></p> 
              <p>{{ error.current.message }}</p>
            </b-alert>
            <b-overlay :show="loading" spinner-variant="secondary">
              <b-button pill type="submit" :disabled="loading" variant="secondary" class="login-btn">Je me connecte</b-button>
            </b-overlay>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
    </b-carousel>
    <footer id="about" class="bg-info w-100">
          <h3>Digital Citizen, qu'est ce que c'est ?</h3>
      <b-container>
        <b-row>
          <b-col sm="12" lg="3" class="bg-primary about-insert">
            <h4>Une initiation à l'informatique</h4>
            <p>
              Digital Citizen est un programme conçu pour permettre à toute personne d'apprendre les bases de l'utilisation d'un ordinateur et d'internet, quelque soit son âge.
            </p>
          </b-col>
          <b-col sm="12" lg="3" class="bg-primary about-insert">
            <h4>Pour tous les grands débutants</h4>
            <p>
              La formation comprend un support papier et numérique pour permettre à chaque apprenant de surmonter son appréhension et se familiariser à ce nouvel univers.
            </p>
          </b-col>
          <b-col sm="12" lg="3" class="bg-primary about-insert">
            <h4>Une progression au rythme de chacun</h4>
            <p>
              Au fur et à mesure de votre apprentissage, testez et validez vos nouvelles compétences informatiques, de manière simple et ludique, grâce à des quiz et des exercices.
            </p>
          </b-col>
        </b-row>
      </b-container>
      <p>Digital Citizen est un programme créé par la <b-link href="https://www.icdlfrance.org/" target="blank">certification ICDL</b-link>, leader international de la certification des compétences numériques.</p>
    </footer>
  </div>

</template>

<script>
import Store from '@/store/index.js'
export default {
    data() {
        return {
          loading: false,
          loginForm: {
            username: "",
            password: ""
          },
          passwordInput: {
            show: false,
            type: "password"
          },
          error: {
            status: false,
            current: {
              title: "",
              message: ""
            },
            default: {
              title: "Une erreur s'est produite lors de la connexion.",
              message: "Si le problème persiste, veuillez vous rapprocher de votre tuteur de formation."
            },
            bad_logout: {
              title: "Il semblerait que vous soyez déjà connecté(e) ou que vous ayez mal fermé votre dernière session.",
              message: "Veuillez patienter 6 minutes avant de refaire une tentative de connexion."
            },
            invalid_grant: {
              title: "Vos identifiants sont incorrects.",
              message: "En cas d'oubli de votre mot de passe, veuillez vous rapprocher de votre tuteur de formation."
            },
          }
        }
    },
    methods: {
      onSubmit() {
        this.error.status = false
        this.loading = true
        Store.dispatch('auth_request', this.loginForm)
        .then( () => {
          // La redirection ne se fait pas à l'aide du router car un bug empêche l'affichage du tableau de bord si l'utilisateur a cliqué sur le lien "en savoir plus" avant de s'identifier
          window.location.href = '/'
        })
        .catch( (err) => {
          if (err.data.error == "bag_logout") {this.error.current = this.error.bad_logout}
          else if (err.data.error == "invalid_grant") {this.error.current = this.error.invalid_grant}
          else {this.error.current = this.error.default}
          this.error.status = true
          this.loading = false
        })
      },
      showPassword() {
        if (this.passwordInput.show === false) {
          this.passwordInput.show = true
          this.passwordInput.type = "text"
        } else {
          this.passwordInput.show = false
          this.passwordInput.type = "password"          
        }
      }
    },
}
</script>

<style scoped>
.login-form-container>.row {
  min-height: 100vh;
}
.full-screen {
  min-height: 100vh;
  height: 100%; 
  width: 100vw;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.carousel-item {
  position: absolute;
}
#slide-1 {
  background-image: url("../assets/login-bg/1.jpg");
}
#slide-2 {
  background-image: url("../assets/login-bg/2.jpg");
}
#slide-3 {
  background-image: url("../assets/login-bg/3.jpg");
}
#slide-4 {
  background-image: url("../assets/login-bg/4.jpg");
}
#login-form, .col {
  padding: 10px 20px;
  border: solid #dadada 0.5px;
  border-radius: 10px;
  margin-top: 1.5rem
}
.form-group {
    margin: 20px 30px;
}
.subtitle {
  font-size: 0.9rem;
}
.logo {
  margin: 10px auto 20px
}
.login-btn {
  margin: 10px auto 10px;
}
#pwd-field {
  display: flex;
}
.input {
  margin-right: 5px
}
.login-card {
  margin-top: 0;
}
footer {
  padding: 20px;
}
footer>.container>.row {
    display: flex;
    justify-content: space-between;
    margin: 1.5em auto;
}
.about-insert {
  color: white;
  padding: 15px;
  border-radius: 10px;
  margin: 1em auto;
  display: grid;
}
.about-insert>h4, footer>h3 {
  font-weight: bold;
}
footer>p {
  margin-bottom: 0;
  font-weight:bold
}
footer a, .login-card a {
  text-decoration: none;
}
</style>